@use '../../scss/utility';

:host {
  --flex-direction: column;
  --spacing: #{utility.wb-pixel-to-rem(16px)};

  display: block;
}

fieldset {
  all: unset;
  display: flex;
  flex-direction: var(--flex-direction);
  gap: var(--spacing);
}

legend {
  position: absolute;
  pointer-events: none;
  opacity: 0;
}

:host([horizontal]) {
  --flex-direction: row;
}
